import { VChip } from 'vuetify/lib/components/VChip';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"deals-status"},[_c(VChip,{class:'deals-status-name deals-status-name-'+_vm.buttonColor.color,attrs:{"small":"","color":_vm.buttonColor.color,"label":"","text-color":_vm.buttonColor.textColor}},[_vm._v(" "+_vm._s(_vm.$t('deals.'+_vm.name))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }